import { PanelLeftOpen } from "lucide-react";

import { LabPanelToggle } from "./LabPanelToggle";

/** The runs pane folded to a slim strip: only the control that opens it. */
export function LabRunsRail({ onExpand }: { onExpand: () => void }) {
  return (
    <nav
      aria-label="History"
      className="flex w-14 shrink-0 flex-col items-center border-border py-3 min-[900px]:h-full min-[900px]:border-e max-[899px]:w-full max-[899px]:flex-row max-[899px]:px-3 max-[899px]:py-1"
    >
      <LabPanelToggle label="Expand history" icon={PanelLeftOpen} onClick={onExpand} />
    </nav>
  );
}
